import React, { useState, useEffect } from 'react';
import Logo from '../components/Logo';

const API = 'https://sendvigo-backend-production.up.railway.app';

const EyeIcon = ({ open }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    {open ? (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
      </>
    ) : (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
      </>
    )}
  </svg>
);

export default function ResetPassword({ token, onDone }) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await fetch(`${API}/auth/reset-password/${token}`);
        const data = await res.json();
        setTokenValid(data.valid === true);
      } catch {
        setTokenValid(false);
      }
      setValidating(false);
    };
    if (token) verify();
    else { setValidating(false); setTokenValid(false); }
  }, [token]);

  const handleReset = async () => {
    setError('');
    if (!password || password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Error al cambiar la contraseña'); setLoading(false); return; }
      setSuccess(true);
    } catch {
      setError('Error conectando con el servidor');
    }
    setLoading(false);
  };

  const inputStyle = {
    backgroundColor: '#13161c', border: '1px solid #2a2d35', color: 'white',
    borderRadius: '14px', padding: '14px 16px', fontSize: '14px', width: '100%', outline: 'none',
  };

  if (validating) return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0d0f14' }}>
      <p style={{ color: '#6b7280' }}>Verificando enlace...</p>
    </div>
  );

  if (!tokenValid) return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" style={{ backgroundColor: '#0d0f14' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
      <h2 style={{ color: 'white', fontWeight: '800', fontSize: '22px', marginBottom: '8px' }}>Enlace inválido</h2>
      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '24px' }}>Este enlace ha expirado o no es válido. Solicita uno nuevo.</p>
      <button onClick={onDone} style={{ backgroundColor: '#f97316', color: 'white', fontWeight: '700', padding: '14px 32px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: 'pointer' }}>
        Volver al login
      </button>
    </div>
  );

  if (success) return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" style={{ backgroundColor: '#0d0f14' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
      <h2 style={{ color: 'white', fontWeight: '800', fontSize: '22px', marginBottom: '8px' }}>¡Contraseña cambiada!</h2>
      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '24px' }}>Ya puedes iniciar sesión con tu nueva contraseña.</p>
      <button onClick={onDone} style={{ backgroundColor: '#f97316', color: 'white', fontWeight: '700', padding: '14px 32px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: 'pointer' }}>
        Iniciar sesión
      </button>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ backgroundColor: '#0d0f14' }}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '300px', background: 'radial-gradient(ellipse 80% 50% at 50% -5%, #f9731612 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div className="w-full max-w-sm relative">
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}><Logo /></div>
          <p style={{ color: '#f97316', fontSize: '12px', fontStyle: 'italic', opacity: 0.8 }}>Juntos llegamos más lejos 🤝</p>
        </div>

        <div style={{ backgroundColor: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '24px', padding: '28px 24px' }}>
          <h2 style={{ color: 'white', fontWeight: '800', fontSize: '20px', marginBottom: '4px' }}>Nueva contraseña</h2>
          <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '24px' }}>Elige una contraseña segura</p>

          <label style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>
            Nueva contraseña
          </label>
          <div style={{ position: 'relative', marginBottom: '16px' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Mínimo 6 caracteres"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{ ...inputStyle, paddingRight: '48px' }}
              className="placeholder-gray-600"
            />
            <button onClick={() => setShowPassword(!showPassword)}
              style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', color: '#4b5563', background: 'none', border: 'none', cursor: 'pointer', display: 'flex' }}>
              <EyeIcon open={showPassword} />
            </button>
          </div>

          {error && (
            <div style={{ backgroundColor: '#ff000015', border: '1px solid #ff000030', color: '#f87171', borderRadius: '10px', padding: '10px 14px', fontSize: '13px', marginBottom: '14px' }}>
              {error}
            </div>
          )}

          <button onClick={handleReset} disabled={loading}
            style={{ backgroundColor: '#f97316', width: '100%', color: 'white', fontWeight: '700', padding: '14px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.8 : 1 }}>
            {loading ? 'Guardando...' : 'Cambiar contraseña'}
          </button>
        </div>
      </div>
    </div>
  );
}